export default __webpack_public_path__ + "static/abcares-volunteer-cc8e829d8656ce5cc48c8b22ff0eac08.jpg";